/* TBS · Product page estilo Mertra: galería, tallas, botón y tarjetas con añadir rápido */
(function () {
  if (window.__tbsMtReady) return;
  window.__tbsMtReady = true;

  var desktopQuery = window.matchMedia('(min-width: 1050px)');
  var hoverQuery = window.matchMedia('(hover: hover)');

  function money(cents, iso) {
    return (Number(cents) / 100).toFixed(2) + ' ' + iso;
  }

  /* ---------- Galería ---------- */
  function initGallery(root) {
    var media = root.querySelector('[data-tbs-mt-media]');
    var track = root.querySelector('[data-tbs-mt-track]');
    var thumbsBox = root.querySelector('[data-tbs-mt-thumbs]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.tbs-mt__thumb'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('.tbs-mt__slide'));
    if (!media || !track || slides.length < 2) return;
    var current = 0;

    function setActive(index) {
      if (index === current && thumbs[index] && thumbs[index].classList.contains('is-active')) return;
      current = index;
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      var thumb = thumbs[index];
      if (!thumb || !thumbsBox) return;
      if (desktopQuery.matches) {
        var top = thumb.offsetTop - thumbsBox.clientHeight / 2 + thumb.clientHeight / 2;
        thumbsBox.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      } else {
        var left = thumb.offsetLeft - thumbsBox.clientWidth / 2 + thumb.clientWidth / 2;
        thumbsBox.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      if (desktopQuery.matches) {
        media.scrollTo({ top: slide.offsetTop, behavior: 'smooth' });
      } else {
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      setActive(index);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var index = 0;
        if (desktopQuery.matches) {
          var mark = media.scrollTop + media.clientHeight / 3;
          slides.forEach(function (slide, i) {
            if (slide.offsetTop <= mark) index = i;
          });
        } else {
          index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        }
        setActive(Math.min(slides.length - 1, Math.max(0, index)));
      });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    media.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Tallas y botón ---------- */
  function initForm(root) {
    var jsonEl = root.querySelector('[data-tbs-mt-json]');
    var idInput = root.querySelector('[data-tbs-mt-id]');
    var atc = root.querySelector('[data-tbs-mt-atc]');
    var atcLabel = root.querySelector('[data-tbs-mt-atc-label]');
    var priceEl = root.querySelector('[data-tbs-mt-price]');
    var compareEl = root.querySelector('[data-tbs-mt-compare]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-tbs-mt-option]'));
    if (!jsonEl || !idInput || !atc) return;

    var data = { variants: [] };
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {}
    var iso = root.dataset.iso || '';
    var anyAvailable = data.variants.some(function (v) {
      return v.available;
    });

    var selected = groups.map(function (group) {
      var chip = group.querySelector('.tbs-mt__chip.is-selected');
      return chip ? chip.dataset.value : null;
    });

    function findVariant() {
      if (!groups.length) return data.variants[0] || null;
      if (selected.some(function (v) { return v === null; })) return null;
      return (
        data.variants.find(function (variant) {
          return variant.options.every(function (opt, i) {
            return opt === selected[i];
          });
        }) || null
      );
    }

    function valueAvailable(groupIndex, value) {
      return data.variants.some(function (variant) {
        if (!variant.available || variant.options[groupIndex] !== value) return false;
        return variant.options.every(function (opt, i) {
          return i === groupIndex || selected[i] === null || selected[i] === opt;
        });
      });
    }

    function refresh(updateUrl) {
      groups.forEach(function (group, gi) {
        group.querySelectorAll('.tbs-mt__chip').forEach(function (chip) {
          var value = chip.dataset.value;
          var isSelected = selected[gi] === value;
          chip.classList.toggle('is-selected', isSelected);
          chip.classList.toggle('tbs-mt__chip--unavail', !valueAvailable(gi, value));
          chip.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });
      });

      var variant = findVariant();
      if (!anyAvailable) {
        if (variant) idInput.value = variant.id;
        atc.setAttribute('aria-disabled', 'true');
        atcLabel.textContent = root.dataset.sold;
        return;
      }
      if (variant) {
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price, iso);
        if (compareEl) {
          if (variant.compare > variant.price) {
            compareEl.textContent = money(variant.compare, iso);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (variant.available) {
          atc.removeAttribute('aria-disabled');
          atcLabel.textContent = root.dataset.atc;
        } else {
          atc.setAttribute('aria-disabled', 'true');
          atcLabel.textContent = root.dataset.sold;
        }
        if (updateUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        idInput.value = '';
        atc.setAttribute('aria-disabled', 'true');
        atcLabel.textContent = root.dataset.select;
      }
    }

    groups.forEach(function (group, gi) {
      group.addEventListener('click', function (event) {
        var chip = event.target.closest('.tbs-mt__chip');
        if (!chip) return;
        if (groups.length === 1 && chip.classList.contains('tbs-mt__chip--unavail')) return;
        selected[gi] = chip.dataset.value;
        group.classList.remove('is-flash');
        refresh(true);
      });
    });

    atc.addEventListener(
      'click',
      function (event) {
        if (!anyAvailable) {
          event.preventDefault();
          return;
        }
        if (idInput.value) return;
        event.preventDefault();
        event.stopPropagation();
        var target =
          groups.find(function (group, gi) {
            return selected[gi] === null;
          }) || groups[0];
        if (!target) return;
        target.classList.remove('is-flash');
        void target.offsetWidth;
        target.classList.add('is-flash');
        window.setTimeout(function () {
          target.classList.remove('is-flash');
        }, 1400);
      },
      true
    );

    refresh(false);
  }

  /* ---------- Tarjetas: fotos, puntos y añadir rápido ---------- */
  function initCard(card) {
    if (card.dataset.tbsMtCardReady) return;
    card.dataset.tbsMtCardReady = '1';
    var track = card.querySelector('[data-tbs-mt-card-track]');
    var dots = Array.prototype.slice.call(card.querySelectorAll('.tbs-mt-card__dot'));
    if (!track || dots.length < 2) return;

    track.addEventListener(
      'scroll',
      function () {
        var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      },
      { passive: true }
    );

    var media = card.querySelector('.tbs-mt-card__media');
    media.addEventListener('mouseenter', function () {
      if (!hoverQuery.matches) return;
      track.scrollTo({ left: track.clientWidth, behavior: 'auto' });
    });
    media.addEventListener('mouseleave', function () {
      if (!hoverQuery.matches) return;
      track.scrollTo({ left: 0, behavior: 'auto' });
    });
  }

  function quickAdd(button) {
    var card = button.closest('[data-tbs-mt-card]');
    var feedback = card ? card.querySelector('[data-tbs-mt-feedback]') : null;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = new FormData();
    body.append('id', button.dataset.tbsMtAdd);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }
    button.classList.add('is-loading');
    button.disabled = true;

    function done(text) {
      button.classList.remove('is-loading');
      button.disabled = false;
      if (feedback && text) {
        feedback.textContent = text;
        feedback.hidden = false;
        window.setTimeout(function () {
          feedback.hidden = true;
        }, 1600);
      }
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          done(response.description || 'Could not add');
          return;
        }
        done('');
        if (card) card.classList.remove('is-open');
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'tbs-mt-card',
            productVariantId: button.dataset.tbsMtAdd,
            cartData: response,
          });
        }
      })
      .catch(function (error) {
        console.error(error);
        done('Could not add');
      });
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-tbs-mt-card-open]');
    if (open) {
      event.preventDefault();
      var card = open.closest('[data-tbs-mt-card]');
      document.querySelectorAll('.tbs-mt-card.is-open').forEach(function (other) {
        if (other !== card) other.classList.remove('is-open');
      });
      if (card) card.classList.toggle('is-open');
      return;
    }
    var add = event.target.closest('[data-tbs-mt-add]');
    if (add && !add.disabled) {
      event.preventDefault();
      quickAdd(add);
      return;
    }
    if (!event.target.closest('[data-tbs-mt-card-sizes]')) {
      document.querySelectorAll('.tbs-mt-card.is-open').forEach(function (card) {
        card.classList.remove('is-open');
      });
    }
  });

  function init() {
    document.querySelectorAll('[data-tbs-mt]').forEach(function (root) {
      if (root.dataset.tbsMtReady) return;
      root.dataset.tbsMtReady = '1';
      initGallery(root);
      initForm(root);
    });
    document.querySelectorAll('[data-tbs-mt-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
